import React, { useEffect, useState } from "react";

import { Checkbox, TextField, Autocomplete, useTheme } from "@mui/material";
import CheckBoxOutlineBlankIcon from "@mui/icons-material/CheckBoxOutlineBlank";
import CheckBoxIcon from "@mui/icons-material/CheckBox";

const icon = <CheckBoxOutlineBlankIcon fontSize="small" />;
const checkedIcon = <CheckBoxIcon fontSize="small" />;

const useStyles = (theme) => ({
    searchBar: {
        width: "30%",
        minWidth: "200px",
        paddingTop: "1.5rem",
        [theme.breakpoints.down("lg")]: {
            width: "90%",
        },
    },
});

const labelMap = {
    edgeDeviceId: "Device ID",
    rtuId: "Device ID",
    polarisId: "Device ID",
    companyName: "Company",
    lineName: "Line Name",
};

export default function SearchBar({ onTagsChange, deviceIds, group, searchGroup }) {
    const theme = useTheme();
    const classes = useStyles(theme);
    const [ids, setIds] = useState(null);
    const [value, setValue] = React.useState([]);

    useEffect(() => {
        if (group !== searchGroup) {
            setValue([]);
        }

        if (deviceIds) {
            let sortByValue = (values) => {
                values.sort((a, b) => {
                    if (!isNaN(a) && !isNaN(b)) {
                        a = Number(a);
                        b = Number(b);

                        return a - b;
                    } else {
                        if (a < b) {
                            return -1;
                        } else if (a > b) {
                            return 1;
                        } else {
                            return 0;
                        }
                    }
                });

                return values;
            };

            let valueMap = {};
            deviceIds.forEach((d) => {
                if (Array.isArray(d[group])) {
                    d[group].forEach((g) => {
                        if (g) {
                            valueMap[g] = true;
                        }
                    });
                } else {
                    if (d[group]) {
                        valueMap[d[group]] = true;
                    }
                }
            });

            let uniqueValues = Object.keys(valueMap);
            let filteredValues = uniqueValues.filter((value) => value);
            let sortedValues = sortByValue(filteredValues);

            setIds(sortedValues);
        }
    }, [deviceIds, group, searchGroup]);

    const handleKeyDown = (event, option) => {
        if (event.key === "Enter" && deviceIds.find((d) => d[group] === event.target.value)) {
            event.preventDefault();
            event.stopPropagation();

            let keys = [...value, event.target.value];

            setValue(keys);

            onTagsChange(null, group, keys);
        } else if (option) {
            setValue(option);
        }
    };

    if (ids && group) {
        let filterLabel = labelMap[group];

        return (
            <Autocomplete
                multiple
                id={`checkboxes-${group}`}
                options={ids}
                name={group}
                disableCloseOnSelect
                value={value}
                getOptionLabel={(option) => {
                    if (option) {
                        return option;
                    } else {
                        return "";
                    }
                }}
                onChange={(e, option) => {
                    handleKeyDown(e, option);
                    onTagsChange(e, group, option);
                }}
                renderOption={(option, { selected }) => {
                    return (
                        <>
                            <Checkbox
                                icon={icon}
                                checkedIcon={checkedIcon}
                                style={{ marginRight: 8 }}
                                checked={value.includes(option)}
                            />
                            {option}
                        </>
                    );
                }}
                sx={classes.searchBar}
                renderInput={(params) => {
                    params.inputProps.onMouseDown = handleKeyDown;
                    params.inputProps.onKeyDown = handleKeyDown;

                    return <TextField {...params} variant="outlined" label={`Filter By ${filterLabel}`} />;
                }}
            />
        );
    } else {
        return null;
    }
}
